module.exports = __webpack_public_path__ + "img/detail_D10E.4f00cad3.png";